/*
  VAULT product-page Add to Cart (assets/product-form.js calls this; Quick Add never does).

  The real Shopify request is sent FIRST by product-form; this only animates and decides when to go to
  /cart once Shopify has answered. Sequence:
    cart rolls in from the left wiping ADD TO CART and parks in the middle; the ACTUAL selected style
    photo (no copy, background keyed out) flies over and drops in behind the rim; the cart turns solid
    → cart rolls out right revealing the exact configuration → ~450ms → SECURING (until Shopify answers)
    → (no SECURED) the page is pulled into the button: zoom + blur + fade to black → /cart (black
      "UNLOCKING YOUR VAULT" arrival, snippets/vault-atc-arrive.liquid).
    Failure branches from SECURING and never leaves the page.
  All motion is transform/opacity Web Animations (compositor); timers, not frames, drive the sequence.
*/
(function () {
  if (window.vaultAtc) return;

  var SEP = ' · ';
  var SUM_PX = 14;
  var EASE_IO = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var EASE_OUT = function (t) { return 1 - Math.pow(1 - t, 3); };
  var swap = function (el, text) { if (window.vaultSwapLabel) window.vaultSwapLabel(el, text); else el.textContent = text; };
  var reduced = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var CART_SVG = '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 3.5h2.6l2.3 11.2a1.6 1.6 0 0 0 1.6 1.3h8.2a1.6 1.6 0 0 0 1.6-1.2L20.6 8H6.1"/><circle cx="9.6" cy="19.6" r="1.3"/><circle cx="17.4" cy="19.6" r="1.3"/></svg>';

  var active = null; // the running flow (one at a time)

  function pretty(v) { return String(v || '').replace(/\s*\([^()]*\)\s*$/, '').trim(); }

  function pickerFor(form) {
    var sec = form.closest('.shopify-section') || document;
    return sec.querySelector('vault-picker');
  }

  // "39 · STANDARD · WITH METAL" from the real current selection; empty parts are dropped cleanly.
  function summaryFor(form, picker) {
    var parts = [];
    if (picker && picker.summaryText) return picker.summaryText(); // the product's own option order
    if (picker && picker.rows && picker.pick) {
      var rank = function (kind) { return { size: 0, quality: 1, style: 3 }[kind] != null ? { size: 0, quality: 1, style: 3 }[kind] : 2; };
      picker.rows.map(function (r, k) { return { r: r, k: k }; })
        .sort(function (a, b) { return rank(a.r.kind) - rank(b.r.kind) || a.k - b.k; })
        .forEach(function (x) { var v = pretty(picker.pick[x.k]); if (v) parts.push(v); });
    } else {
      var input = form.querySelector('[name="id"]');
      var list = (window.Shopify && window.Shopify.variants) || [];
      var v = input && list.find(function (x) { return String(x.id) === String(input.value); });
      if (v && v.options) v.options.forEach(function (o) { o = pretty(o); if (o && o !== 'Default Title') parts.push(o); });
    }
    return parts.join(SEP).toUpperCase();
  }

  function Flow(form) {
    this.form = form;
    this.btn = form.querySelector('[type="submit"]');
    this.label = this.btn && this.btn.querySelector(':scope > span');
    this.picker = pickerFor(form);
    this.summary = summaryFor(form, this.picker);
    this.reduced = reduced();
    var self = this;
    this.result = new Promise(function (r) { self.settle = r; });
    this.visualDone = Promise.resolve();
    this.packed = null;
    this.layer = null;
  }

  // ---------- 2 + 3: cart wipe, park, the actual style pack, exit (one coordinated mechanism) ----------
  // Butter-smooth rule: every moving part is a transform/opacity Web Animation (compositor, never redrawn
  // per frame), all started together on one timeline; timers (not frames) drive the sequence.
  //   0 → ENTER   cart rolls in from the left to the middle; ADD TO CART dissolves behind/ahead of it
  //   LIFT…IN     the ACTUAL style photo (background keyed out) lifts, flies over, hovers, drops in –
  //               the cart's rim clips it bottom-first, so it goes INSIDE; on impact the cart turns solid
  //   EXIT → END  cart rolls out to the right, revealing the exact configuration behind it
  var SAMPLES = 90;
  function track(fn) { // keyframes of fn(ms-fraction) – linear between dense samples = smooth
    var k = [];
    for (var i = 0; i <= SAMPLES; i++) { var f = fn(i / SAMPLES); f.offset = i / SAMPLES; k.push(f); }
    return k;
  }
  var CART_SOLID = '<svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2.5 3.5h2.6l.6 3"/>' +
    '<path class="vault-atc-basket" fill="currentColor" fill-opacity="0" d="M5.7 7.5h14.9l-1.7 7.3a1.6 1.6 0 0 1-1.6 1.2H9a1.6 1.6 0 0 1-1.6-1.3z"/>' +
    '<circle class="vault-atc-basket" fill="currentColor" fill-opacity="0" cx="9.6" cy="19.6" r="1.3"/><circle class="vault-atc-basket" fill="currentColor" fill-opacity="0" cx="17.4" cy="19.6" r="1.3"/></svg>';
  var tx = function (x, y) { return 'translate3d(' + x + 'px,' + (y || 0) + 'px,0)'; };
  var CART_ENTER_EASE = 'cubic-bezier(0.22, 0.8, 0.3, 1)';
  // Hover and click use the same cart entry and soft-edged wipe.
  function cartEntry(from, to, cartW, W, EDGE, end, ease) {
    var coverX = function (x) { return x + cartW / 2 + 6 - (W + EDGE); };
    return {
      cart: [
        { transform: tx(from), offset: 0, easing: ease },
        { transform: tx(to), offset: end }
      ],
      cover: [
        { transform: tx(coverX(from)), offset: 0, easing: ease },
        { transform: tx(coverX(to)), offset: end }
      ]
    };
  }

  Flow.prototype.start = function () {
    var self = this;
    var btn = this.btn, label = this.label;
    if (!btn || !label) return;
    btn.classList.add('vault-atc-run');
    if (this.reduced || !this.summary) {
      takeTease(btn);
      this.visualDone = (function () {
        if (self.summary) swap(label, self.summary);
        return wait(self.summary ? 650 : 0);
      })();
      return;
    }
    var br = btn.getBoundingClientRect();
    var img = this.styleImage(br);
    // timeline (ms from the tap)
    var T = img
      ? { enter: 1200, lift: 600, travel: 900, hover: 2400, drop: 2600, inside: 3100, exit: 3550, end: 4350 }
      : { enter: 1100, exit: 1500, end: 2300 };

    var cs = getComputedStyle(label);
    var bg = getComputedStyle(btn).backgroundColor;
    if (!bg || /rgba\(0, 0, 0, 0\)|transparent/.test(bg)) bg = '#000';
    var layer = document.createElement('span');
    layer.className = 'vault-atc-layer';
    layer.setAttribute('aria-hidden', 'true');
    layer.innerHTML = '<span class="vault-atc-cover"></span><span class="vault-atc-win"><span class="vault-atc-sum"></span></span><span class="vault-atc-veil"></span><span class="vault-atc-cart"><span class="vault-atc-cart-in">' + CART_SOLID + '</span></span>';
    var cover = layer.children[0], win = layer.children[1], sum = win.firstChild, veil = layer.children[2], cart = layer.children[3], cartIn = cart.firstChild;
    var W = br.width, H = br.height, cartW = Math.round(Math.min(34, H * 0.56)), EDGE = 26;
    cover.style.background = 'linear-gradient(90deg, ' + bg + ' calc(100% - ' + EDGE + 'px), transparent)';
    cover.style.width = (W + EDGE) + 'px';
    win.style.width = W + 'px';
    win.style.webkitMaskImage = win.style.maskImage = 'none';
    veil.style.width = (W + 2 * EDGE) + 'px';
    veil.style.background = 'linear-gradient(90deg, transparent, ' + bg + ' ' + EDGE + 'px, ' + bg + ')';
    sum.style.width = W + 'px';
    sum.textContent = this.summary;
    sum.style.fontFamily = cs.fontFamily;
    sum.style.fontSize = SUM_PX + 'px'; // the configuration reads smaller than the command
    sum.style.letterSpacing = cs.letterSpacing;
    sum.style.fontWeight = cs.fontWeight;
    btn.appendChild(layer);
    this.layer = layer;
    // Long configurations shrink to fit the button (never wrap or spill).
    var rg = document.createRange(); rg.selectNodeContents(sum);
    var inner = rg.getBoundingClientRect().width;
    // Letter spacing stays fixed when the font shrinks: reserve it before fitting the glyphs.
    var tracking = (parseFloat(cs.letterSpacing) || 0) * Array.from(this.summary).length;
    var fit = inner > W - 28
      ? Math.max(1, SUM_PX * Math.max(1, W - 28 - tracking) / Math.max(1, inner - tracking)) : SUM_PX;
    sum.style.fontSize = fit + 'px';
    this.fit = fit;
    cart.style.width = cart.style.height = cartW + 'px';
    cart.style.top = (H - cartW) / 2 + 'px';

    var E = T.end, o = function (ms) { return Math.min(1, ms / E); };
    var IN = CART_ENTER_EASE, OUT = 'cubic-bezier(0.55, 0, 0.35, 1)';
    var x0 = -cartW - 10, xc = (W - cartW) / 2, x1 = W + 10;
    // Hovered first: the teaser cart is already part-way in – carry on from exactly where it is.
    var teased = takeTease(btn);
    if (teased != null) x0 = teased;
    var mid = function (x) { return x + cartW / 2; };
    var opts = { duration: E, fill: 'forwards' };
    var entry = cartEntry(x0, xc, cartW, W, EDGE, o(T.enter), IN);
    var anims = [
      // cart: in → parked in the middle → out
      cart.animate(entry.cart.concat([
        { transform: tx(xc), offset: o(T.exit), easing: OUT },
        { transform: tx(x1), offset: 1 }
      ]), opts),
      // soft-edged cover rides just behind the cart: ADD TO CART dissolves as it passes
      cover.animate(entry.cover.concat([
        { transform: tx(mid(xc) + 6 - (W + EDGE)), offset: 1 }
      ]), opts),
      // what's still ahead of the parked cart fades too: only the cart is left in the button
      label.animate([
        { opacity: 1, offset: 0 }, { opacity: 1, offset: o(T.enter * 0.5) },
        { opacity: 0, offset: o(T.enter) }, { opacity: 0, offset: 1 }
      ], opts),
      // leaving: the configuration opens up behind the cart (window +X, text −X = text stands still)
      // leaving: the configuration stands still; one black veil (soft left edge) slides off it to the right
      // with the cart – a single moving layer, so the text can't shimmer on phones
      veil.animate([
        { transform: tx(mid(xc) - 4 - EDGE), offset: 0 },
        { transform: tx(mid(xc) - 4 - EDGE), offset: o(T.exit), easing: OUT },
        { transform: tx(mid(x1) - 4 - EDGE), offset: 1 }
      ], opts),
      sum.animate([
        { opacity: 0, offset: 0 },
        { opacity: 0, offset: o(T.exit), easing: OUT },
        { opacity: 1, offset: 1 }
      ], opts)
    ];
    if (img) {
      // impact: the cart dips and floods solid (same language as Quick Add's lock)
      anims.push(cartIn.animate([
        { transform: tx(0, 0) }, { transform: tx(0, 2.5), offset: 0.35 }, { transform: tx(0, 0) }
      ], { duration: 320, delay: T.inside - 40, easing: 'cubic-bezier(0.3, 0.7, 0.4, 1)' }));
      [].forEach.call(cart.querySelectorAll('.vault-atc-basket'), function (el) {
        anims.push(el.animate([{ fillOpacity: 0 }, { fillOpacity: 1 }], { duration: 380, delay: T.inside - 20, easing: 'ease-out', fill: 'forwards' }));
      });
      this.pack(img, T, { x: br.left + mid(xc), top: br.top + (H - cartW) / 2, w: cartW, btnTop: br.top });
    }
    this.anims = (this.anims || []).concat(anims);

    // Timers (not frames, not onfinish): the sequence always completes, even if animations are paused.
    this.visualDone = wait(E).then(function () {
      // Cart has left on the right: the label becomes the configuration (same spot, no jump).
      label.textContent = self.summary;
      if (self.fit) label.style.fontSize = self.fit + 'px';
      (self.anims || []).forEach(function (a) { a.cancel(); });
      self.anims = null;
      layer.remove();
      self.layer = null;
      return wait(450);
    });
  };

  Flow.prototype.styleImage = function (br) {
    var p = this.picker;
    if (!p) return null;
    var tile = p.querySelector('.vault-picker__row--tiles .vault-picker__tile.is-on');
    var img = tile && tile.querySelector('.vault-picker__img img');
    if (!img || !img.complete || !img.naturalWidth) return null; // no real photo → skip the pack
    var r = img.getBoundingClientRect();
    if (!r.width || r.bottom < 0 || r.top > window.innerHeight) return null; // not on screen: nothing to see
    if (br && r.bottom > br.top + br.height / 2) return null; // photo below the cart: can't drop in from above
    return img;
  };

  // The photo's white studio background → transparent (same <img>, its own pixels; restored after).
  function keyOut(img) {
    try {
      var w = img.naturalWidth, h = img.naturalHeight;
      if (!w || !h || w * h > 1200 * 1200) return null;
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, 0, 0);
      var d = x.getImageData(0, 0, w, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var m = Math.min(p[i], p[i + 1], p[i + 2]);
        if (m >= 246) p[i + 3] = 0;
        else if (m >= 226) p[i + 3] = Math.round(p[i + 3] * (246 - m) / 20);
      }
      x.putImageData(d, 0, 0);
      return c.toDataURL('image/png');
    } catch (e) { return null; } // e.g. a cross-origin image: fly it as it is
  }

  // The ACTUAL <img> leaves its tile (no copy) into a fixed layer whose bottom edge is the cart's rim:
  // it lifts, flies over to the parked cart, shrinks, hovers, and drops in – the rim clips it bottom-first,
  // so it reads as going INSIDE the cart (the cart is drawn in front). One precomputed animation.
  Flow.prototype.pack = function (img, T, c) {
    var self = this;
    var r = img.getBoundingClientRect();
    var attr = function (n) { return img.getAttribute(n); };
    this.packed = { img: img, parent: img.parentNode, next: img.nextSibling, style: attr('style'), src: attr('src'), srcset: attr('srcset'), sizes: attr('sizes') };
    // Hold the slot open while the photo is away, so the caption under it never moves.
    var hold = document.createElement('span');
    hold.className = 'vault-atc-hold';
    hold.setAttribute('aria-hidden', 'true');
    hold.style.cssText = 'display:block;width:' + img.offsetWidth + 'px;height:' + img.offsetHeight + 'px;margin:' + getComputedStyle(img).margin + ';';
    img.parentNode.insertBefore(hold, img);
    this.packed.hold = hold;
    // the tile's crop goes along (out of the tile its object-fit fell back: the photo jumped smaller at once)
    var ics = getComputedStyle(img), fit = ics.objectFit, pos = ics.objectPosition;
    var clean = keyOut(img);
    var rim = c.top + c.w * 0.275; // just above the basket's top stroke, so the stroke stays in front
    var fly = document.createElement('div');
    fly.className = 'vault-atc-fly';
    document.body.appendChild(fly);
    var o = fly.getBoundingClientRect(); // "fixed" may be offset by a transformed ancestor
    fly.style.height = Math.max(0, rim - o.top) + 'px';
    this.fly = fly;
    if (clean) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = clean; }
    img.classList.add('vault-atc-photo');
    img.style.cssText = 'position:absolute;margin:0;left:' + (r.left - o.left) + 'px;top:' + (r.top - o.top) + 'px;width:' + r.width + 'px;height:' + r.height +
      'px;max-width:none;mix-blend-mode:normal;background:transparent;transform-origin:50% 50%;will-change:transform;pointer-events:none;' +
      'object-fit:' + fit + ';object-position:' + pos + ';';
    fly.appendChild(img);
    var c0x = r.left + r.width / 2, c0y = r.top + r.height / 2;
    var size = c.w * 0.82, s1 = size / r.width;
    var hoverY = Math.min(c.btnTop - size * 0.55 - 8, c.top - size * 0.6);
    var endY = rim + size * 0.62; // whole photo below the rim = inside
    var E = T.end;
    var lerp = function (a, b, k) { return a + (b - a) * k; };
    var frames = track(function (f) {
      var ms = f * E, x = 0, y = 0, s = 1;
      if (ms < T.lift) { /* still in its slot */ }
      else if (ms < T.travel) {
        var e = EASE_OUT((ms - T.lift) / (T.travel - T.lift));
        y = -10 * e; s = 1 + 0.06 * e;
      } else if (ms < T.hover) {
        var k = EASE_IO((ms - T.travel) / (T.hover - T.travel));
        x = (c.x - c0x) * k;
        y = lerp(-10, hoverY - c0y, k) - 34 * Math.sin(Math.PI * k); // a soft arc over to the cart
        s = lerp(1.06, s1, k);
      } else if (ms < T.drop) {
        var h = (ms - T.hover) / (T.drop - T.hover);
        x = c.x - c0x; y = hoverY - c0y - 3 * Math.sin(Math.PI * h); s = s1; // a breath above the cart
      } else {
        var v = Math.min(1, (ms - T.drop) / (T.inside - T.drop));
        x = c.x - c0x; y = lerp(hoverY, endY, v * v) - c0y; s = s1;
      }
      return { transform: 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + s + ')' };
    });
    this.anims = (this.anims || []).concat(img.animate(frames, { duration: E, easing: 'linear', fill: 'forwards' }));
    setTimeout(function () { self.finishPack(); }, T.inside + 60);
  };

  // Fully inside: put the real element back where it lives, hidden, with its own styles.
  Flow.prototype.finishPack = function () {
    if (this.packDone) return;
    this.packDone = true;
    var p = this.packed;
    if (!p) return;
    if (p.img.getAnimations) p.img.getAnimations().forEach(function (a) { a.cancel(); });
    p.img.classList.remove('vault-atc-photo');
    ['src', 'srcset', 'sizes'].forEach(function (n) { if (p[n] == null) p.img.removeAttribute(n); else if (p.img.getAttribute(n) !== p[n]) p.img.setAttribute(n, p[n]); });
    if (p.style == null) p.img.removeAttribute('style'); else p.img.setAttribute('style', p.style);
    p.img.style.setProperty('opacity', '0', 'important'); // new-style tiles force opacity:1 !important
    p.parent.insertBefore(p.img, p.next && p.next.parentNode === p.parent ? p.next : null);
    if (p.hold) { p.hold.remove(); p.hold = null; } // same frame as the photo returns: no reflow gap
    if (this.fly) { this.fly.remove(); this.fly = null; }
  };

  // Make the tile photo visible again (instantly under the black screen, or a soft fade after a failure).
  Flow.prototype.revealPacked = function (fade) {
    var p = this.packed;
    if (!p) return;
    if (!this.packDone) this.finishPack();
    var img = p.img;
    if (fade && img.animate) {
      var a = img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
      setTimeout(function () { a.cancel(); }, 300); // never left invisible if animations are paused
    }
    if (p.style == null) img.removeAttribute('style'); else img.setAttribute('style', p.style);
    this.packed = null;
  };

  // ---------- SECURING → (Shopify confirms) → pulled into the button ----------
  Flow.prototype.run = function () {
    var self = this;
    this.start();
    return this.visualDone.then(function () {
      // the size goes back to normal in the same instant the text changes (hidden mid-swap), never before
      var lbl = self.label;
      if (self.fit && window.MutationObserver) {
        var mo = new MutationObserver(function () { lbl.style.fontSize = ''; mo.disconnect(); });
        mo.observe(lbl, { childList: true, characterData: true, subtree: true });
        setTimeout(function () { mo.disconnect(); lbl.style.fontSize = ''; }, 1000);
      }
      swap(lbl, 'SECURING');
      return Promise.all([self.result, wait(420)]);
    }).then(function (res) {
      var r = res[0];
      if (r.ok) return self.success(r.url);
      return self.failure(r.response);
    });
  };

  // Shopify confirmed: straight from SECURING into the page transition (no SECURED step).
  Flow.prototype.success = function (url) {
    if (this.reduced) return this.expand(url);
    return this.pull(url);
  };

  // We're pulled INTO the button: the page zooms toward it, blurs, and fades into black (the black is
  // behind the page, not a shape coming at us). Transform/opacity on a few big layers + one fading
  // backdrop blur – all compositor work. Navigate once it's essentially black.
  Flow.prototype.pull = function (url) {
    var self = this;
    var go = function () {
      try { sessionStorage.setItem('vault-atc-arrive', String(Date.now())); } catch (e) {}
      window.vaultSkipLeave = true; // the preloader's white leave-veil must not cover the black
      // the packed photo stays gone (it's in the cart); reset() brings it back on back/forward
      window.location.href = url;
    };
    var br = this.btn.getBoundingClientRect();
    var cx = br.left + br.width / 2, cy = br.top + br.height / 2;
    var vw = window.innerWidth, vh = window.innerHeight;
    var targets = [].filter.call(document.body.children, function (el) {
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(el.tagName) || el.id === 'vault-preloader-wrap' || el.classList.contains('vault-leave') || el.classList.contains('vault-atc-fly')) return false;
      var s = getComputedStyle(el);
      return s.display !== 'none' && s.position !== 'fixed';
    });
    // Fixed things inside them (header bar, sticky Add to Cart) would jump once their ancestor is
    // transformed: pin them where they are first, so they zoom away with everything else.
    this.pinned = [];
    var pins = [];
    targets.forEach(function (t) {
      [].forEach.call(t.querySelectorAll('*'), function (el) {
        var s = getComputedStyle(el);
        if (s.position !== 'fixed' || s.display === 'none') return;
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height || r.bottom < 0 || r.top > vh) return;
        pins.push({ el: el, r: r });
      });
    });
    pins.forEach(function (p) {
      self.pinned.push({ el: p.el, style: p.el.getAttribute('style') });
      p.el.style.setProperty('position', 'absolute', 'important');
      p.el.style.setProperty('top', '0px', 'important');
      p.el.style.setProperty('left', '0px', 'important');
      p.el.style.setProperty('right', 'auto', 'important');
      p.el.style.setProperty('bottom', 'auto', 'important');
      p.el.style.setProperty('width', p.r.width + 'px', 'important');
      p.el.style.setProperty('margin', '0', 'important');
    });
    pins.forEach(function (p) { // second pass: correct by what moved (offset parents differ)
      var n = p.el.getBoundingClientRect();
      p.el.style.setProperty('top', (p.r.top - n.top) + 'px', 'important');
      p.el.style.setProperty('left', (p.r.left - n.left) + 'px', 'important');
    });

    var back = document.createElement('div');
    back.className = 'vault-atc-back';
    var haze = document.createElement('div');
    haze.className = 'vault-atc-haze';
    document.body.appendChild(back);
    document.body.appendChild(haze);
    this.pullLayers = [back, haze];
    // Editorial, not a crash zoom: a slow, small lean in (6%), the page softening out of focus, and
    // the darkness arriving last – a held breath, then we're inside.
    var dx = (vw / 2 - cx) * 0.1, dy = (vh / 2 - cy) * 0.1;
    var D = 1250, EASE = 'cubic-bezier(0.45, 0, 0.2, 1)';
    var anims = [];
    targets.forEach(function (t) {
      var r = t.getBoundingClientRect();
      t.style.transformOrigin = (cx - r.left) + 'px ' + (cy - r.top) + 'px';
      t.style.willChange = 'transform, opacity';
      // a small drift that brings the button toward the middle of the screen while we lean in
      anims.push(t.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.35 + 'px, ' + dy * 0.35 + 'px) scale(1.015)', opacity: 1, offset: 0.3 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(1.04)', opacity: 0 }
      ], { duration: D, easing: EASE, fill: 'forwards' }));
    });
    this.pullTargets = targets;
    anims.push(back.animate([{ opacity: 0 }, { opacity: 0, offset: 0.75 }, { opacity: 1 }], { duration: D, easing: 'ease-in', fill: 'forwards' }));
    anims.push(haze.animate([{ opacity: 0 }, { opacity: 1, offset: 0.6 }, { opacity: 1 }], { duration: D, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' }));
    this.pullAnims = anims;
    setTimeout(go, D * 0.92);
  };

  Flow.prototype.expand = function (url) {
    var self = this;
    var go = function () {
      try { sessionStorage.setItem('vault-atc-arrive', String(Date.now())); } catch (e) {}
      window.vaultSkipLeave = true; // the preloader's white leave-veil must not cover the black
      // the packed photo stays gone (it's in the cart); reset() brings it back on back/forward
      window.location.href = url;
    };
    var r = this.btn.getBoundingClientRect();
    var black = document.createElement('div');
    black.className = 'vault-atc-black';
    this.black = black;
    if (this.reduced) {
      black.style.cssText = 'left:0;top:0;width:100vw;height:100vh;opacity:0;';
      document.body.appendChild(black);
      var o0 = black.getBoundingClientRect();
      black.style.left = -o0.left + 'px'; black.style.top = -o0.top + 'px';
      var a = black.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: 'ease-out', fill: 'forwards' });
      setTimeout(go, 240);
      return;
    }
    // Square corners: a scaled radius would stretch into ovals (the 1–2px difference is gone in a frame).
    black.style.cssText = 'left:0;top:0;width:' + r.width + 'px;height:' + r.height + 'px;';
    document.body.appendChild(black);
    var o = black.getBoundingClientRect(); // "fixed" may be offset by a transformed ancestor
    black.style.left = (r.left - o.left) + 'px';
    black.style.top = (r.top - o.top) + 'px';
    var vw = window.innerWidth, vh = window.innerHeight;
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var sx = (2 * Math.max(cx, vw - cx) + 4) / r.width;
    var sy = (2 * Math.max(cy, vh - cy) + 4) / r.height;
    var D = 720;
    black.animate([
      { transform: 'scale(1, 1)' },
      { transform: 'scale(' + sx + ', 1)', offset: 0.42 },
      { transform: 'scale(' + sx + ', ' + sy + ')' }
    ], { duration: D, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'forwards' });
    setTimeout(go, D * 0.92); // ~90–95% covered
  };

  // ---------- Failure: from SECURING, never leaves the page ----------
  Flow.prototype.failure = function (response) {
    var self = this;
    this.revealPacked(true);
    var desc = String((response && (response.description || response.message)) || '');
    var specific = null;
    if (response && /sold out|not available|unavailable|no longer/i.test(desc)) specific = this.unavailableNow();
    var first = specific ? specific.say : "COULDN'T SECURE";
    var then = specific ? specific.then : 'TRY AGAIN';
    swap(this.label, first);
    return wait(specific ? 900 : 800).then(function () {
      swap(self.label, then);
      self.end(specific ? 'wait' : null);
    });
  };

  // Shopify said this variant can't be bought: show it as unavailable on the option most likely to change.
  Flow.prototype.unavailableNow = function () {
    var p = this.picker;
    if (!p || !p.data) return null;
    var input = this.form.querySelector('[name="id"]');
    var v = p.data.variants.find(function (x) { return String(x.id) === String(input && input.value); });
    if (v) v.available = false;
    var pick = function (kind) { var k = p.rows.findIndex(function (r) { return r.kind === kind; }); return k; };
    var k = pick('size'), word = 'SIZE';
    if (k < 0) { k = pick('style'); word = 'STYLE'; }
    if (k < 0) { k = pick('quality'); word = 'QUALITY'; }
    if (k < 0) return { say: 'JUST SOLD OUT', then: 'CHOOSE ANOTHER OPTION' };
    var value = pretty(p.pick[k]).replace(/\s*\(.*?\)\s*/g, ' ').trim();
    p.confirmed[k] = false;
    p.paint();
    return { say: (word === 'SIZE' ? 'SIZE ' + value : value) + ' JUST SOLD OUT', then: 'CHOOSE ANOTHER ' + word };
  };

  // Hand the button back (no cart left inside it).
  Flow.prototype.end = function (state) {
    var btn = this.btn;
    if (this.anims) { this.anims.forEach(function (a) { a.cancel(); }); this.anims = null; }
    if (this.layer) { this.layer.remove(); this.layer = null; }
    if (this.label) { this.label.style.webkitMaskImage = this.label.style.maskImage = ''; this.label.style.fontSize = ''; }
    btn.classList.remove('vault-atc-run');
    btn.classList.toggle('vault-cta-wait', state === 'wait');
    btn.removeAttribute('aria-disabled');
    active = null;
  };

  // Back/forward cache: the product page must come back exactly as it was.
  Flow.prototype.reset = function () {
    this.revealPacked(false);
    if (this.fly) { this.fly.remove(); this.fly = null; }
    if (this.black) { this.black.remove(); this.black = null; }
    if (this.pullAnims) { this.pullAnims.forEach(function (a) { a.cancel(); }); this.pullAnims = null; }
    if (this.pullLayers) { this.pullLayers.forEach(function (n) { n.remove(); }); this.pullLayers = null; }
    if (this.pullTargets) { this.pullTargets.forEach(function (t) { t.style.transformOrigin = ''; t.style.willChange = ''; }); this.pullTargets = null; }
    if (this.pinned) { this.pinned.forEach(function (p) { if (p.style == null) p.el.removeAttribute('style'); else p.el.setAttribute('style', p.style); }); this.pinned = null; }
    if (this.label) {
      // only our own animations: cancelling the theme's CSS load-in would leave the text at its opacity 0 start
      this.label.getAnimations && this.label.getAnimations().forEach(function (a) { if (!a.animationName) a.cancel(); });
      // the theme's load-in starts the text at opacity 0 – on a restored page pin it fully visible
      this.label.style.animation = 'none';
      this.label.style.opacity = '1';
      var text = this.picker && this.picker.ctaText ? this.picker.ctaText() : ((window.variantStrings && window.variantStrings.addToCart) || 'Add to cart');
      this.label.textContent = text;
    }
    this.end(null);
  };

  window.addEventListener('pageshow', function (e) {
    window.vaultSkipLeave = false;
    if (active && e.persisted) active.reset();
  });

  // ---------- Hover teaser: the click animation's first moment, frozen ----------
  // Hover previews the existing click entry, stopping at the first letter of ADD TO CART.
  // Its existing soft-edged wipe fades only the text it has reached. Clicking continues from there.
  // Leaving rolls it back out; re-entering carries on from the current position.
  var TEASE_IN = 650, TEASE_OUT = 350;
  /* R44 #6 (Mark, 2026-10-26): no cart hint on Android at all – neither the automatic first-encounter hint nor the
     finger-down hint. On his Android the parked hint still came in a second time at the tap after the scroll fix, so the
     cart now comes in once, with the add itself. Desktop hover and iPhone keep the hint. */
  var NO_TEASE = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent || '');
  function teaseReady(btn) {
    if (NO_TEASE) return false;
    if (!btn || reduced() || active) return false;
    if (btn.classList.contains('vault-atc-run') || btn.classList.contains('vault-cta-wait')) return false;
    if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled || btn.offsetParent === null) return false;
    var info = btn.closest('product-info');
    if (info && info.classList.contains('vault-bn-closed') && !info.classList.contains('vault-bn-resolved')) return false; // VIEW OPTIONS
    var label = btn.querySelector(':scope > span');
    return !!(label && /add to cart/i.test(label.textContent));
  }
  /* R44 #6 diagnostics (Mark's Android: the parked hint vanishes at the tap and the cart drives in again from the left –
     not reproduced with CDP touches on the same phone): every teaser step goes to window.__vaultLog (the debug recorder keeps
     it when the page was opened with ?vaultdebug=1) and, with that flag, to a small on-screen list Mark can screenshot. */
  var dbgBox = null;
  function atcDebug(msg) {
    try {
      if (window.__vaultLog) window.__vaultLog('atc: ' + msg);
      if (localStorage.getItem('vault_debug') !== '1') return;
      if (!dbgBox) {
        dbgBox = document.createElement('pre');
        dbgBox.id = 'vault-atc-debug';
        dbgBox.style.cssText = 'position:fixed;left:0;bottom:0;z-index:2147483647;max-width:100vw;max-height:38vh;overflow:hidden;margin:0;padding:4px 6px;font:10px/1.25 monospace;color:#000;background:rgba(255,255,255,.92);pointer-events:none;white-space:pre-wrap';
        (document.body || document.documentElement).appendChild(dbgBox);
      }
      var lines = (dbgBox.textContent ? dbgBox.textContent.split('\n') : []).concat([(performance.now() | 0) + ' ' + msg]).slice(-22);
      dbgBox.textContent = lines.join('\n');
    } catch (e) {}
  }
  function teaseState(btn) {
    var t = btn && btn.vaultTease;
    if (!t) return 'none' + (btn && btn.vaultTeaseGone ? ' gone@' + (Date.now() - btn.vaultTeaseGone.at) + 'ms x=' + Math.round(btn.vaultTeaseGone.x) : '');
    var x = null; try { x = Math.round(curX(t)); } catch (e) {}
    return 'x=' + x + (t.leaving ? ' leaving' : '') + ' ' + t.anims.map(function (a) { return a.playState; }).join('/') + (t.layer.isConnected ? '' : ' DETACHED');
  }
  function tease(btn) {
    if (!teaseReady(btn)) return;
    var t = btn.vaultTease;
    /* R44 #6: a hint already parked at the first letter is left exactly as it is – no cancel + restart of its animation on
       the finger-down, so nothing can read a half-started animation at the click */
    if (t && !t.leaving && t.anims.length && Math.abs(curX(t) - t.xT) < 1) return;
    if (!t) {
      var label = btn.querySelector(':scope > span');
      var br = btn.getBoundingClientRect(), W = br.width, H = br.height;
      var cartW = Math.round(Math.min(34, H * 0.56)), EDGE = 26;
      var bg = '#000'; // the button's own black (a hover colour must never become the cover)
      btn.classList.add('vault-atc-tease'); // the teaser stays inside the button
      var layer = document.createElement('span');
      layer.className = 'vault-atc-layer';
      layer.setAttribute('aria-hidden', 'true');
      layer.innerHTML = '<span class="vault-atc-cover"></span><span class="vault-atc-cart"><span class="vault-atc-cart-in">' + CART_SOLID + '</span></span>';
      var cover = layer.children[0], cart = layer.children[1];
      cover.style.background = 'linear-gradient(90deg, ' + bg + ' calc(100% - ' + EDGE + 'px), transparent)';
      cover.style.width = (W + EDGE) + 'px';
      cart.style.width = cart.style.height = cartW + 'px';
      cart.style.top = (H - cartW) / 2 + 'px';
      btn.appendChild(layer);
      var x0 = -cartW - 10;
      // Measure the first command letter, not the wider selected-options line below it.
      var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT), text;
      while ((text = walker.nextNode()) && !/\S/.test(text.nodeValue)) {}
      if (!text) { layer.remove(); btn.classList.remove('vault-atc-tease'); return; }
      var first = text.nodeValue.search(/\S/), rg = document.createRange();
      rg.setStart(text, first); rg.setEnd(text, first + 1);
      var letter = rg.getBoundingClientRect();
      var xT = Math.max(x0, Math.min(W - cartW, letter.left - br.left + letter.width / 2 - cartW / 2));
      t = btn.vaultTease = { layer: layer, cart: cart, cover: cover, x0: x0, xT: xT, cartW: cartW, W: W, EDGE: EDGE, anims: [] };
    }
    move(t, t.xT, TEASE_IN, CART_ENTER_EASE);
  }
  function untease(btn, why) {
    var t = btn && btn.vaultTease;
    if (!t || t.leaving) return;
    t.leaving = true;
    // where the hint was when it was sent back: a tap within the next 1.2 s continues the cart from there (takeTease)
    try { btn.vaultTeaseGone = { x: curX(t), at: Date.now() }; } catch (e) {}
    atcDebug('untease(' + (why || '?') + ') ' + teaseState(btn));
    move(t, t.x0, TEASE_OUT, 'cubic-bezier(0.4, 0, 1, 1)');
    t.timer = setTimeout(function () { if (btn.vaultTease === t) { t.layer.remove(); btn.vaultTease = null; btn.classList.remove('vault-atc-tease'); } }, TEASE_OUT + 30);
  }
  function curX(t) {
    var tr = getComputedStyle(t.cart).transform;
    // no computed transform yet (an animation that has not produced its first frame): the position we were moving from
    if (!tr || tr === 'none') return t.fromX != null ? t.fromX : t.x0;
    var m = new DOMMatrixReadOnly(tr);
    return m.m41;
  }
  function move(t, to, ms, ease) {
    clearTimeout(t.timer);
    t.leaving = to === t.x0;
    var from = t.anims.length ? curX(t) : t.x0;
    t.anims.forEach(function (a) { a.cancel(); });
    t.fromX = from;
    var entry = cartEntry(from, to, t.cartW, t.W, t.EDGE, 1, ease);
    var o = { duration: ms, fill: 'forwards' };
    t.anims = [
      t.cart.animate(entry.cart, o),
      t.cover.animate(entry.cover, o)
    ];
  }
  // The real flow takes over: returns where the cart is now (or null when there was no teaser).
  function takeTease(btn) {
    var t = btn.vaultTease;
    atcDebug('takeTease ' + teaseState(btn));
    if (!t) {
      /* R44 #6: the hint was sent back a moment ago (whatever did it): the cart still continues from where it was parked
         instead of driving in again from the left – the "cart appears twice" on Mark's Android */
      var gone = btn.vaultTeaseGone; btn.vaultTeaseGone = null;
      return gone && Date.now() - gone.at < 1200 ? gone.x : null;
    }
    btn.vaultTeaseGone = null;
    clearTimeout(t.timer);
    var x = curX(t);
    t.anims.forEach(function (a) { a.cancel(); });
    t.layer.remove();
    btn.vaultTease = null;
    btn.classList.remove('vault-atc-tease');
    return x;
  }
  var ATC = '[id^="ProductSubmitButton-"]';
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var b = e.target.closest && e.target.closest(ATC);
    if (b && !(e.relatedTarget && b.contains(e.relatedTarget))) tease(b);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var b = e.target.closest && e.target.closest(ATC);
    if (b && !(e.relatedTarget && b.contains(e.relatedTarget)) && !b.classList.contains('vault-atc-run')) untease(b, 'pointerout');
  });
  // phones: finger down = the teaser; lifting = the tap (click) continues it; scrolling away cancels it
  var touchBtn = null, ty0 = 0, tx0 = 0;
  document.addEventListener('touchstart', function (e) {
    var b = e.target.closest && e.target.closest(ATC);
    if (!b) return;
    touchBtn = b; tx0 = e.touches[0].clientX; ty0 = e.touches[0].clientY;
    atcDebug('touchstart on button, before: ' + teaseState(b) + ' target=' + (e.target && e.target.className || e.target && e.target.tagName));
    tease(b);
    atcDebug('touchstart after tease: ' + teaseState(b));
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!touchBtn) return;
    var p = e.touches[0];
    if (Math.abs(p.clientX - tx0) > 10 || Math.abs(p.clientY - ty0) > 10) { untease(touchBtn, 'touchmove ' + Math.round(p.clientX - tx0) + ',' + Math.round(p.clientY - ty0)); touchBtn = null; }
  }, { passive: true });
  document.addEventListener('touchcancel', function () { if (touchBtn) untease(touchBtn, 'touchcancel'); touchBtn = null; }, { passive: true });
  // a real tap on the button: the parked cart waits for the add-to-cart run to take it over (on a slow Android the run started
  // after the 450 ms fold-back, so the cart rolled out and came in again – "the cart appears twice", Mark R36 blocker)
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest(ATC); if (b) { b.vaultAtcTapAt = Date.now(); atcDebug('click ' + teaseState(b)); } }, true);
  document.addEventListener('touchend', function () {
    var b = touchBtn; touchBtn = null;
    if (b) atcDebug('touchend ' + teaseState(b));
    // the click follows right away; if it doesn't (e.g. the press turned into nothing), fold back
    if (b) setTimeout(function fold() {
      if (!b.vaultTease || b.classList.contains('vault-atc-run')) return;
      if (b.vaultAtcTapAt && Date.now() - b.vaultAtcTapAt < 4000) { setTimeout(fold, 250); return; }
      untease(b, 'fold');
    }, 450);
  }, { passive: true });

  // ---------- Phones: FIRST ENCOUNTER ----------
  // The CTA fully on screen AND the shopper at rest ~620ms → the same teaser as the desktop hover plays by
  // itself (in, then it stays parked – R43). Passing through while scrolling does nothing; scrolling during it
  // rolls it back. Once per product per browser session (sessionStorage): scrolling away/back, options,
  // size/style changes and back/forward never replay it; a new product may play once.
  (function () {
    if (NO_TEASE || !window.matchMedia || !window.matchMedia('(hover: none)').matches) return; // Android: no hint (R44 #6)
    var REST = 620, rest = null, autoBtn = null, holdT = null, stopWhy = null;
    // Only after the shopper has really touched the page: while it loads (photos not in yet, preloader
    // on top) the button can sit "on screen" for a moment – it played there unseen and got used up.
    var engaged = false;
    var key = function (b) {
      var f = b.form || (b.getAttribute('form') && document.getElementById(b.getAttribute('form')));
      var pid = f && f.querySelector('[name="product-id"]');
      return 'vault-atc-teased-' + (pid ? pid.value : location.pathname);
    };
    var played = function (b) { try { return sessionStorage.getItem(key(b)) === '1'; } catch (e) { return true; } };
    var fully = function (b) {
      var r = b.getBoundingClientRect();
      return r.height > 0 && r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    };
    // Cut short by the shopper (a dropdown, a style button, scrolling): it did not really play, so it may
    // play again once they are at rest.
    var stopAuto = function (cut) {
      clearTimeout(holdT);
      // a hint that fully arrived did play: leaving it (scroll, another tap) never makes it play again
      if (cut && autoBtn && !autoBtn.vaultAutoParked) { try { sessionStorage.removeItem(key(autoBtn)); } catch (e) {} }
      if (autoBtn && autoBtn.vaultTease && !autoBtn.classList.contains('vault-atc-run')) untease(autoBtn, 'auto-stop ' + (stopWhy || '?'));
      if (autoBtn) autoBtn.vaultAutoParked = false;
      autoBtn = null; stopWhy = null;
    };
    var check = function () {
      rest = null;
      if (!engaged || autoBtn || active || document.hidden || document.querySelector('.vault-preloader-active, html.is-loading')) return;
      // A dropdown is open (or a field is focused): wait, and start counting again once it is closed.
      var fe = document.activeElement;
      if (fe && /^(SELECT|INPUT|TEXTAREA)$/.test(fe.tagName)) return;
      if (document.querySelector('product-info [aria-expanded="true"], product-info details[open]')) { arm(); return; }
      document.querySelectorAll(ATC).forEach(function (b) {
        if (autoBtn || played(b) || !fully(b) || b.vaultTease || !teaseReady(b)) return;
        try { sessionStorage.setItem(key(b), '1'); } catch (e) { return; }
        autoBtn = b;
        tease(b);
        /* R43 P1-3-02 (Mark): the hint stays parked at the first letter – it used to slide back out after HOLD, so a tap
           after it brought the cart in a second time (Android "the cart appears twice"). Scrolling away, a tap
           elsewhere or a field/dropdown still send it back (stopAuto); a tap on the button continues it. */
        holdT = setTimeout(function () { if (autoBtn === b) { b.vaultAutoParked = true; b.vaultParkedY = window.scrollY; } }, TEASE_IN);
      });
    };
    var arm = function () { clearTimeout(rest); rest = setTimeout(check, REST); };
    arm(); // already resting on it at load
    // VIEW OPTIONS → (open) → CHOOSE YOUR SIZE → (size picked) → ADD TO CART: every label/state change
    // re-arms, timed from the END of the swap animation (180ms out + 450ms in), so the teaser only starts
    // once ADD TO CART has fully settled – never on top of the other animation.
    if (window.MutationObserver) {
      var settle = null;
      var mo = new MutationObserver(function () {
        if (autoBtn) return;
        clearTimeout(settle);
        settle = setTimeout(arm, 700);
      });
      var watchBtns = function () {
        document.querySelectorAll(ATC).forEach(function (b) {
          if (b.vaultMo) return;
          b.vaultMo = true;
          mo.observe(b, { attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'], childList: true, characterData: true, subtree: true });
          var info = b.closest('product-info');
          if (info) mo.observe(info, { attributes: true, attributeFilter: ['class'] });
        });
      };
      watchBtns();
      document.addEventListener('DOMContentLoaded', watchBtns);
    }
    /* R44 #6 (Mark's Android "cart appears twice"): a parked hint survives a small scroll – a thumb nudge, the URL bar
       moving, the page settling – while the button stays fully on screen. Only scrolling away (button leaves the screen
       or > 80 px) sends it back. The debug log showed the parked hint sent back by a scroll right before the tap. */
    window.addEventListener('scroll', function () {
      if (autoBtn) {
        var nudge = autoBtn.vaultAutoParked && fully(autoBtn) && Math.abs(window.scrollY - (autoBtn.vaultParkedY || 0)) < 80;
        if (!nudge) { stopWhy = 'scroll y=' + Math.round(window.scrollY); stopAuto(true); }
      }
      arm();
    }, { passive: true });
    // Dropdown picked or closed: the count starts again from zero.
    document.addEventListener('change', arm, true);
    document.addEventListener('focusout', arm, true);
    document.addEventListener('focusin', function (e) { clearTimeout(rest); if (autoBtn) { stopWhy = 'focusin ' + (e.target && (e.target.id || e.target.tagName)); stopAuto(true); } }, true);
    document.addEventListener('touchstart', function (e) {
      engaged = true;
      clearTimeout(rest);
      // a finger on the button itself takes the teaser over (the tap continues it)
      if (autoBtn && !(e.target.closest && e.target.closest(ATC) === autoBtn)) { stopWhy = 'touch elsewhere ' + (e.target && (e.target.className || e.target.tagName)); stopAuto(true); }
      else if (autoBtn) { clearTimeout(holdT); autoBtn = null; }
    }, { passive: true });
    document.addEventListener('touchend', arm, { passive: true });
    document.addEventListener('click', arm, true); // e.g. VIEW OPTIONS opened → ADD TO CART now showing
  })();

  // R49: adding a variant that is already a cart line makes Shopify raise that line where it sits, low in the cart. Mark
  // wants it back at the TOP like a new line. So: read the cart, drop the matching line, re-add it with the combined
  // quantity (a new line goes on top). Returns a promise of the add Response, exactly like fetch(addUrl, config), so
  // product-form (and the drawer's `sections`) work unchanged. Any doubt or error = the plain add, so adding never breaks.
  window.vaultCartAdd = function (config, formData, addUrl) {
    function log(msg) { if (window.__vaultLog) window.__vaultLog('cart add: ' + msg); }
    function plain() { return fetch(addUrl, config); }
    function norm(props) { // sorted, blank values dropped: {} / null / undefined all compare equal
      var out = [];
      if (props) Object.keys(props).sort().forEach(function (k) { if (props[k] !== '' && props[k] != null) out.push([k, String(props[k])]); });
      return JSON.stringify(out);
    }
    var id, qty, props = {}, plan = null, entries = [];
    try {
      id = formData && formData.get && formData.get('id');
      if (!id) return plain();
      qty = parseInt(formData.get('quantity'), 10);
      if (!(qty > 0)) qty = 1;
      var it = formData.entries(), step;
      while (!(step = it.next()).done) {
        entries.push(step.value);
        var m = /^properties\[(.*)\]$/.exec(step.value[0]);
        if (m) props[m[1]] = step.value[1];
      }
      var sp = formData.get('selling_plan');
      if (sp) plan = String(sp);
    } catch (e) { return plain(); }

    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    }
    function restore(line, why) { // put the shopper's old line back, best effort
      log('restore ' + line.key + ' qty ' + line.quantity + ' (' + why + ')');
      if (window.__vaultLog) window.__vaultLog('cart add restore ' + line.key);
      var body = { id: line.variant_id || id, quantity: line.quantity, properties: line.properties || {} };
      if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) body.selling_plan = line.selling_plan_allocation.selling_plan.id;
      return post('/cart/add.js', body).catch(function () {});
    }

    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    }).then(function (cart) {
      var line = null, items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var l = items[i], lp = l.selling_plan_allocation && l.selling_plan_allocation.selling_plan ? String(l.selling_plan_allocation.selling_plan.id) : null;
        if (String(l.variant_id || l.id) === String(id) && norm(l.properties) === norm(props) && lp === plan) { line = l; break; }
      }
      if (!line) return plain();
      log('merging line ' + line.key + ' qty ' + line.quantity + '+' + qty);
      return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function (r) {
        if (!r.ok) { log('remove failed ' + r.status + ', plain add'); return plain(); }
        var fd = new FormData(); // clone: the original formData is left alone
        entries.forEach(function (e) { if (e[0] === 'quantity') return; fd.append(e[0], e[1]); });
        fd.set('quantity', String(line.quantity + qty));
        var cfg = {};
        Object.keys(config).forEach(function (k) { cfg[k] = config[k]; });
        cfg.body = fd;
        return fetch(addUrl, cfg).then(function (res) {
          if (res.ok) return res;
          return restore(line, 'add ' + res.status).then(function () { return res; });
        }, function (err) {
          return restore(line, 'add error').then(function () { throw err; });
        });
      });
    }).catch(function (err) {
      log('fallback ' + (err && err.message));
      return plain();
    });
  };

  window.vaultAtc = {
    can: function (productForm) {
      return !!(productForm && productForm.querySelector('[type="submit"] > span') && !active);
    },
    // Called by product-form right AFTER it has sent the real request.
    begin: function (productForm) {
      // A second caller must join the running flow, never replay its cart/photo sequence (R43 P1-3-02); another form's
      // request while one runs is answered by the running flow, which also takes the shopper to the cart.
      if (active) return active.form === productForm ? active.handle : { succeed: function () {}, fail: function () {} };
      var flow = new Flow(productForm);
      active = flow;
      flow.handle = {
        succeed: function (url) { flow.settle({ ok: true, url: url }); },
        fail: function (response) { flow.settle({ ok: false, response: response }); }
      };
      flow.run().catch(function () { flow.reset(); });
      return flow.handle;
    }
  };
})();
